exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ou__files__primary-drag-label {\n  background: #337ab7;\n  color: white;\n  display: none;\n  font-size: 9px;\n  padding: 1px 4px 0 4px;\n  position: absolute;\n  right: -10px;\n  top: 10px;\n  text-transform: uppercase;\n  z-index: 500;\n}\n.ou--primary .ou__files li {\n  cursor: move;\n}\n.ou__files li.ou__files--primary .ou__files__primary-drag-label {\n  display: block;\n}\n.ou__files li.ou__files__primary-drag-placeholder {\n  background: #fff0df;\n  border: 3px dashed #ccc;\n}\n", ""]);

// exports
